import { Controller } from "@hotwired/stimulus"
import { ArcElement, Chart, DoughnutController, Tooltip } from "chart.js"

Chart.register(ArcElement, DoughnutController, Tooltip)

export default class extends Controller {
  static targets = [ "canvas" ]
  static values = {
    labels: Array,
    values: Array
  }

  connect() {
    if (!this.hasCanvasTarget) return

    const values = this.normalizedValues()
    if (values.every((value) => value <= 0)) return

    this.chart = new Chart(this.canvasTarget, {
      type: "doughnut",
      data: {
        labels: this.labelsValue,
        datasets: [
          {
            data: values,
            backgroundColor: [ "#5B60E6", "#B882FF" ],
            borderWidth: 0,
            borderRadius: 6,
            hoverOffset: 4,
            spacing: 2
          }
        ]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        cutout: "72%",
        animation: {
          duration: 700
        },
        plugins: {
          legend: {
            display: false
          },
          tooltip: {
            displayColors: false,
            backgroundColor: "#111111",
            titleColor: "#F8FAFC",
            bodyColor: "#E2E8F0",
            padding: 12,
            callbacks: {
              label: (context) => `${context.label}: ${Number(context.raw).toLocaleString("ja-JP")}人`
            }
          }
        }
      }
    })
  }

  disconnect() {
    if (!this.chart) return

    this.chart.destroy()
    this.chart = null
  }

  normalizedValues() {
    return this.valuesValue.map((value) => Number(value) || 0)
  }
}
